import {AcSelect} from '@/dashboard/ui/FormControl';
/** Frozen quarter-hour choices, retaining an existing recorded non-quarter hour. */
export function coverageTimeOptions(saved:string):string[]{
 const values=Array.from({length:96},(_,i)=>`${String(Math.floor(i/4)).padStart(2,'0')}:${String(i%4*15).padStart(2,'0')}`);
 if(/^([01]\d|2[0-3]):[0-5]\d$/.test(saved)&&!values.includes(saved))values.push(saved);
 return values.sort();
}
export default function CoverageTimeSelect({id,value,onChange,disabled=false}:{id:string;value:string;onChange:(value:string)=>void;disabled?:boolean}){
 return <AcSelect id={id} value={value} disabled={disabled} onChange={e=>onChange(e.target.value)}><option value="">Choose time</option>{coverageTimeOptions(value).map(t=>{const [h,m]=t.split(':').map(Number);return <option key={t} value={t}>{h%12||12}:{String(m).padStart(2,'0')} {h<12?'AM':'PM'}</option>})}</AcSelect>;
}
